export default __webpack_public_path__ + "static/media/averagedefectcount.39f313f5.svg";